import type { AudioSettings } from '../../features/settings/domain/audioSettings';
import {
  audioSettingsSchema,
  DEFAULT_AUDIO_SETTINGS,
} from '../../features/settings/domain/audioSettings';
import { gameDatabase } from '../../infrastructure/database/gameDatabase';

export interface SettingsRepository {
  loadAudio(): Promise<AudioSettings>;
  saveAudio(settings: AudioSettings): Promise<void>;
}

export const indexedDbSettingsRepository: SettingsRepository = {
  async loadAudio() {
    const row = await gameDatabase.settings.get('audio');
    const result = audioSettingsSchema.safeParse(row?.payload);
    return result.success ? result.data : DEFAULT_AUDIO_SETTINGS;
  },
  async saveAudio(settings) {
    const valid = audioSettingsSchema.parse(settings);
    await gameDatabase.settings.put({
      id: 'audio',
      updatedAtUtc: Date.now(),
      payload: valid,
    });
  },
};
